import { uniqWith } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { PlateOption, PlateType } from '@paragon/contract-library';
import {
  getLoggedInUsersOrganizationMaterialSet,
  plateTypeWithTangibleTypesEqualityComparator,
} from '@paragon/material-lists';

import { plateOptionsAreEqual } from '../../plateOptionsAreEqual';
import { getActiveComponentDesign } from './getActiveComponentDesignSelector';

type PlateOptionWithComboPlateInfo = PlateOption & {
  readonly tangiblePlateTypesForComboPlateType: readonly PlateType[];
};

export const getUniquePlatesInMaterialSetForActiveComponentDesign = createSelector(
  getLoggedInUsersOrganizationMaterialSet,
  getActiveComponentDesign,
  (materialSet, activeComponentDesign): PlateOptionWithComboPlateInfo[] => {
    if (!materialSet || !activeComponentDesign) return [];

    const plateList = materialSet.plateLists[activeComponentDesign.materialSelection.plateListGuid];

    return plateList ? uniqWith(plateList.plates, plateOptionsAreEqual) : [];
  },
);

export const getPlateTypesInInventory = createSelector(
  getUniquePlatesInMaterialSetForActiveComponentDesign,
  (uniquePlates) =>
    uniqWith(
      uniquePlates.map((plate) => ({
        plateType: plate.plateType,
        tangiblePlateTypesForComboPlateType: plate.tangiblePlateTypesForComboPlateType,
      })),
      plateTypeWithTangibleTypesEqualityComparator,
    ),
);
